import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from '@/interfaces';
import {
	FinancialFilters,
	FinancialList,
	FinancialSummary,
} from '@/interfaces';

class FinancialRecoveryService {
	constructor(private client: AxiosInstance) {}

	async getAll({
		year,
	}: {
		year: number | undefined;
	}): Promise<HttpResponse<FinancialList>> {
		const params = {
			...(year && { year }),
		};
		return this.client.get(`/financial?page=1&limit=100`, { params });
	}

	async getFilters(): Promise<HttpResponse<FinancialFilters>> {
		return this.client.get('/financial/filters');
	}

	async getSummary({
		year,
	}: {
		year: number | undefined;
	}): Promise<HttpResponse<FinancialSummary>> {
		const params = {
			...(year && { year }),
		};
		return this.client.get('/financial/data', { params });
	}
}

export const financialRecoveryService = new FinancialRecoveryService(
	axiosClient
);
